import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core'
import { list, read } from 'actions/data'
import {
  selectConversation,
  toggleContactViewPanel,
  listInbox,
} from 'actions/inbox'
// import fakeList from 'actions/inbox/fakeList'
import { receiveContact } from 'actions/contacts/addOrEdit'
import ConversationsList from './ConversationsList'
import ContactMobileView from './ContactMobileView'
import ContactSummary from './ContactSummary'
import SearchBox from './SearchBox'
// import Thread from './Thread/'
// import Input from './Input'
import { getContactsWithEmails } from 'actions/contacts'
import ThreadAndInput from './ThreadAndInput'
// import ConversationsListTabs from './ConversationsListTabs'

const styles = theme => ({
  conversationsListColumn: {
    backgroundColor: '#fff',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      flex: '0 0 25%',
      borderRight: '1px solid #e5e5e5',
    },
    zIndex: 1,
  },
  contactThreadColumn: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('md')]: {
      flex: '2 0 0%',
      borderRight: '1px solid #e5e5e5',
    },
    height: '100%',
    backgroundColor: '#fff',
    position: 'relative',
  },
  contactColumn: {
    flex: '3',
    flexDirection: 'column',
    display: 'flex',
  },
  contactView: {
    display: 'flex',
    flex: '1 1 0%',
    flexDirection: 'row-reverse',
  },
})

export default connect(
  state => ({
    conversationSelected: state.inbox.conversationSelected,
    contactSelected: state.inbox.contactSelected,
    conversationsListFilter: state.inbox.conversationsListFilter,
  }),
  dispatch =>
    bindActionCreators(
      {
        list,
        // fakeList,
        read,
        receiveContact,
        selectConversation,
        toggleContactViewPanel,
        getContactsWithEmails,
        listInbox,
      },
      dispatch,
    ),
)(
  withStyles(styles)(
    class InboxDesktop extends Component {
      componentDidMount() {
        const {
          // list,
          read,
          selectConversation,
          conversationSelected,
          toggleContactViewPanel,
          getContactsWithEmails,
          contactSelected,
          listInbox,
          // conversationsListUserFilter,
        } = this.props

        getContactsWithEmails().then(payload => {
          if (payload.length && !contactSelected) {
            toggleContactViewPanel(true)
          }
        })

        if (!conversationSelected && !contactSelected) {
          listInbox({
            infiniteLoader: false,
            // endpoint: this.props.conversationsListFilter,
          }).then(payload => {
            if (payload?.response?.length) {
              read(
                payload?.response?.[0].contact_id,
                'inbox',
                'inbox/conversation',
                'contact_id',
              ).then(payload => {
                selectConversation(payload.contact.id)
              })
            }
          })
        }
      }

      render() {
        const { classes, location } = this.props
        return (
          <Fragment>
            <div className={classes.conversationsListColumn}>
              <SearchBox />
              {/* <ConversationsListTabs /> */}
              <ConversationsList />
            </div>
            <div className={classes.contactColumn}>
              <div className={classes.contactView}>
                <ContactMobileView location={location} />
                <div className={classes.contactThreadColumn}>
                  <ContactSummary />
                  <ThreadAndInput />
                </div>
              </div>
            </div>
          </Fragment>
        )
      }
    },
  ),
)
